import { transformDateToLocalDateString, useTranslate } from "helpers";
import { memo } from "react";
import { ContactNoteTabProps } from "./types";
import { NoResults } from "ui/components/NoResults";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";

const ContactNoteTab: React.FC<ContactNoteTabProps> = (props) => {
  const { searchResults, isLoading, onRowClick, onDeleteClick } = props;

  const { t } = useTranslate();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (searchResults.pagination.totalPages === 0) {
    return <NoResults message={t("admin.contact.note.search.noresults")} />;
  }

  return (
    <div className="flex flex-col gap-3 p-4 max-h-[1000px] overflow-y-auto">
      {searchResults.data.map((note) => (
        <div
          key={note.id}
          onClick={() => onRowClick(note.id)}
          className={`
            relative p-4 rounded-sm cursor-pointer transition-all flex gap-4
            ${note.important
              ? "bg-red-50 border-l-4 border-red-500 hover:bg-red-100"
              : "bg-slate-50 border-l-4 border-slate-300 hover:bg-slate-100"
            }
          `}
        >
          <div className="flex-shrink-0">
            <TableIcon
              imageUrl={note.userCreated?.avatar}
              initials={`${note.userCreated?.firstName?.charAt(0)?.toUpperCase() ?? ""}${note.userCreated?.lastName?.charAt(0)?.toUpperCase() ?? ""}`}
            />
          </div>
          <div className="flex-1 min-w-0">
            {/* Header s datumom i akcijama */}
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                {note.userCreated && (
                  <span className="text-sm font-medium text-slate-700">
                    {`${note.userCreated.firstName ?? ""} ${note.userCreated.lastName ?? ""}`.trim()}
                  </span>
                )}
                {note.important && (
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800">
                    <img
                      src="/media/icons/warning.svg"
                      alt=""
                      className="w-3 h-3 mr-1"
                    />
                    {t("admin.contact.note.important")}
                  </span>
                )}
                <span className="text-xs text-slate-500">
                  {transformDateToLocalDateString(note.created)}
                </span>
              </div>
              <button
                onClick={(e) => onDeleteClick(e, note.id)}
                className="p-1 rounded hover:bg-slate-200 transition-colors"
                title={t("admin.delete")}
              >
                <img
                  src="/media/icons/trash.svg"
                  alt={t("admin.delete")}
                  className="w-4 h-4 opacity-50 hover:opacity-100"
                />
              </button>
            </div>

            {/* Sadržaj bilješke */}
            <p className="text-sm text-slate-700 whitespace-pre-wrap">
              {note.content}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(ContactNoteTab);
